export default {
  apiEndpoint: process.env.REACT_APP_API_URL,
  socketUrl: process.env.REACT_APP_SOCKET_URL,
  isDevMode: process.env.REACT_APP_MODE === 'development',
  googleKey: process.env.REACT_APP_GOOGLE_KEY,
};
